import React from 'react';

/**
 * Helipad SVG converted to a React component
 * @param {Object} props - Component props
 * @param {string} props.color - Color to apply to the SVG (default: 'currentColor')
 * @param {string} props.width - Width of the SVG (default: '24px')
 * @param {string} props.height - Height of the SVG (default: '24px')
 * @param {Object} props.style - Additional style properties
 * @param {string} props.className - CSS class name
 */
const HelipadIcon = ({ 
  color = 'currentColor', 
  width = '24px', 
  height = '24px',
  style = {},
  className = '',
  ...rest
}) => {
  return (
    <svg 
      width={width} 
      height={height}
      viewBox="0 0 1200 1200"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...style }}
      className={className}
      {...rest}
    >
      <title>Helipad Icon</title>
      <path 
        fill={color} 
        d="m600 100c-275.55 0-500 224.45-500 500s224.45 500 500 500 500-224.45 500-500-224.45-500-500-500zm0 100c221.5 0 400 178.5 400 400s-178.5 400-400 400-400-178.5-400-400 178.5-400 400-400zm-125 175c-13.262 0-25.977 5.2695-35.355 14.645-9.375 9.3789-14.645 22.094-14.645 35.355v350c0 13.262 5.2695 25.977 14.645 35.355 9.3789 9.375 22.094 14.645 35.355 14.645s25.98-5.2695 35.355-14.645c9.375-9.3789 14.645-22.094 14.645-35.355v-125h150v125c0 13.262 5.2695 25.977 14.645 35.355 9.375 9.375 22.094 14.645 35.355 14.645s25.977-5.2695 35.355-14.645c9.375-9.3789 14.645-22.094 14.645-35.355v-350c0-13.262-5.2695-25.977-14.645-35.355-9.3789-9.375-22.094-14.645-35.355-14.645s-25.98 5.2695-35.355 14.645c-9.375 9.3789-14.645 22.094-14.645 35.355v125h-150v-125c0-13.262-5.2695-25.977-14.645-35.355-9.375-9.375-22.094-14.645-35.355-14.645z"
      />
    </svg>
  );
};

export default HelipadIcon;
